<template>
    <div class="top-bar-settings__container">
        <div class="top-bar-settings__list top-bar-settings__list--1">
            <a class="top-bar-settings__item top-bar-settings__item--1" :href="link1">{{ text1 }}</a>
            <a class="top-bar-settings__item top-bar-settings__item--2" :href="link2">{{ text2 }}</a>
            <a class="top-bar-settings__item top-bar-settings__item--3" :href="link3">{{ text3 }}</a>
            <a class="top-bar-settings__item top-bar-settings__item--4" :href="link4">{{ text4 }}</a>
            <a class="top-bar-settings__item top-bar-settings__item--5" :href="link5">{{ text5 }}</a>
        </div>
        <div class="top-bar-settings__list top-bar-settings__list--2">
            <a class="top-bar-settings__item top-bar-settings__item--6" :href="link6"><img :src="img1" alt="icon">{{ text6 }}</a>
            <a class="top-bar-settings__item top-bar-settings__item--7" :href="link7"><img :src="img2" alt="icon">{{ text7 }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            text1: String,
            text2: String,
            text3: String,
            text4: String,
            text5: String,
            text6: String,
            text7: String,

            link1: String,
            link2: String,
            link3: String,
            link4: String,
            link5: String,
            link6: String,
            link7: String,

            img1: String,
            img2: String,
        }
    }
</script>
